export default __webpack_public_path__ + "img/bellOutline.37e965f9.svg";